// extracted by mini-css-extract-plugin
module.exports = {"tableHeader":"TableHeader-module--tableHeader--3uJAt"};